<template>
  <div>
    <div class="num-tip">共{{list.length}}个部门</div>
    <el-form :model="formData" ref="formRef"  @submit.native.prevent label-width="80px">
        <el-form-item label="部门:" >
            <span class="font12px">{{ list.map(v=>v.name).join('、') }}</span>
        </el-form-item>
         <el-form-item label="产能:" prop="production_capacity" :rules="{ required: true, message: '请输入产能', trigger: 'blur' }">
            <el-input-number 
                v-model="formData.production_capacity" 
                style="width: 200px"
                :controls="false" 
                :step="1" 
                :min="1"
                :max="9999"
                step-strictly 
                placeholder="请输入数字"
            />
         </el-form-item>
    </el-form>
    <div class="tac mt40">
         <el-button @click="$emit('close')" :disabled="submitLoading">取消</el-button>
         <el-button type="primary" @click="onSubmit" :loading="submitLoading">确定</el-button>
    </div>
  </div>
</template>

<script>
import API from '@/api/workOrder/conf'
export default {
    name:'EditCapacityModal',
    props:['list', 'cbs'],
    data(){
        let production_capacity = undefined;
        if (this.list.length === 1) {
           production_capacity = this.list[0].production_capacity || undefined;
        }
        return {
            submitLoading:false,
            formData:{
                production_capacity,
            }
        }
    },
    methods:{
        async onSubmit(){
            await this.$refs.formRef.validate();
            try {
                this.submitLoading = true
                const params ={
                    ids: this.list.map(v=>v.id),
                    production_capacity: this.formData.production_capacity,
                };
                await API.editProductionCapacityConfigInfo(params);
                this.cbs.onSubmit();
            } catch (error) {
                this.$message.error(error.info);
            }finally {
                this.submitLoading = false
            }
           
        }
    }
}
</script>

<style lang="scss" scoped>
.num-tip {
    font-size: 14px;
    color: #9c9c9c;
    position: absolute;
    top: 11px;
    left: 90px;
}
</style>